module.exports = __webpack_public_path__ + "static/media/ny.6f1cc862.mp4";